import { OAuthSettings } from './../../../oauth';
import { AlertService } from './alert.service';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { User } from '../classes/user';
import { Client } from '@microsoft/microsoft-graph-client';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  public authenticated: boolean;
  public user: User;

  public  Msal: any;
  public graphUser: any;
  public graphClient: any;
  public result: any;
  public token: any;
  constructor(
    private msalService: MsalService,
    private alertsService: AlertService) {

    this.authenticated = false;
    this.user = null;
  }

  // Prompt the user to sign in and
  // grant consent to the requested permission scopes
  async signIn(userLogin: string): Promise<void> {
    this.authenticated = false;
    this.user = null;

    const signOAuth = {
        appId: 'a01f76c9-e85b-4d66-87b0-6273f6073ac0',
        scopes: [
          'user.read'
        ],
        loginHint: userLogin
    };
    this.result = await this.msalService.loginPopup(signOAuth)
      .catch((reason) => {
        this.alertsService.error('Login failed');
      });

    if (this.result) {
      this.authenticated = true;
      // Temporary placeholder
      this.user = await this.getUser();
    }
  }
  private async getUser(): Promise<User> {
    if (!this.authenticated) { return null; }

    this.graphClient = Client.init({
      // Initialize the Graph client with an auth
      // provider that requests the token from the
      // auth service
      authProvider: async(done) => {
        this.token = await this.getAccessToken()
          .catch((reason) => {
            done(reason, null);
          });

        if (this.token) {
          done(null, this.token);
        } else {
          done('Could not get an access token', null);
        }
      }
    });

    // Get the user from Graph (GET /me)
    this.graphUser = await this.graphClient.api('/me').get();

    this.user = new User();
    this.user.displayName = this.graphUser.displayName;
    // Prefer the mail property, but fall back to userPrincipalName
    this.user.email = this.graphUser.mail || this.graphUser.userPrincipalName;

    return this.user;
  }
  // Sign out
  signOut(): void {
    this.msalService.logout();
    this.user = null;
    this.authenticated = false;
  }

  // Silently request an access token
  async getAccessToken(): Promise<string> {
    this.result = await this.msalService.acquireTokenSilent(OAuthSettings)
      .catch((reason) => {
        this.alertsService.error('Get token failed');
      });

    if (this.result) {
      // Temporary to display token in an error box
      // this.alertsService.error('Token acquired');
      return this.result.accessToken;
    }
    return null;
  }
}
